import React from 'react'
import { LiveChatLoaderProvider, Drift } from 'react-live-chat-loader'
import { DRIFT_PROVIDER_KEY } from 'root/src/client/v2/layout/fixtures/layout.fixtures'

export default () => (
	<LiveChatLoaderProvider
		idlePeriod="1000"
		providerKey={DRIFT_PROVIDER_KEY}
		provider="drift"
	>
		<Drift color="#5FC49A" />
	</LiveChatLoaderProvider>
)
